export enum SuccessTypes {
	None,
	OnCreate,
	OnUpdate,
	OnDelete,
}
